<template>
  <v-select
    v-model="context.value.value[props.field.key]"
    :label="label"
    color="primary"
    :prepend-inner-icon="props.field.properties.icon"
    :items="transformedItems"
  ></v-select>
</template>
<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed } from 'vue'

import { i18n } from '@/lang/setup'

import type { SchemaFormKitProps } from './types'

const context = useFormKitContext()
const props = defineProps<SchemaFormKitProps>()
const transformedItems = computed(() => {
  if (props.field.properties?.options) {
    return props.field.properties.options.map((item) => {
      return {
        title: item.text,
        value: item.value,
      }
    })
  } else if (props.field.templateOptions?.options) {
    return props.field.templateOptions.options.map((item) => {
      return {
        title: item.text,
        value: item.value,
      }
    })
  } else if (props.field.options) {
    return props.field.options.map((item) => {
      return {
        title: item.text,
        value: item.value,
      }
    })
  }
  return []
})
const label = computed(() => {
  if (props.field.properties?.label) {
    return i18n.global.t(props.field.properties?.label)
  }
  return ''
})
</script>
